import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IdentityStorage } from '../../../auth/_models/identity.storage';
import { BaseComponent } from '../../base/base.component';
import { Http } from '@angular/http';
import { AuthenticationService } from '../../../auth/_services';
import { LocalStorageService } from 'angular-web-storage';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [     
    trigger('upState1', [
      state('up', style({ transform: 'translateY(-6%)'})),   
      state('default', style({ transform: 'translateY(6%)'})),     
      
      transition('default => up', animate('200ms ease-out')),          
   
  ]
  ),
     trigger('upState2', [
      state('up', style({ transform: 'translateY(-6%)'})),
      state('default', style({ transform: 'translateY(6%)'})), 

      transition('default => up', animate('200ms ease-out'))           
  ]
  ),
      trigger('upState3', [
      state('up', style({ transform: 'translateY(-6%)'})), 
      state('default', style({ transform: 'translateY(6%)'})), 

      transition('default => up', animate('200ms ease-out'))           
  ]
  ),
      trigger('upState4', [
      state('up', style({ transform: 'translateY(-6%)'})), 
      state('default', style({ transform: 'translateY(6%)'})), 

      transition('default => up', animate('200ms ease-out'))           
  ]
)    
] 
})
export class HeaderComponent implements BaseComponent {

  response: string;
  api: string;
  currentUser: any;
  flagHome = false;
  bntStyle: string;

  constructor(
    public router: Router,
    public http: Http, 
    public identityStorage: IdentityStorage,
    private authenticationService : AuthenticationService,
    private local: LocalStorageService,
  ) {}


  HeaderComponent() {

    this.bntStyle = 'btn-default';
   }
   submit() {
     this.bntStyle = 'btn-change';
 
   }
 
  ngOnInit() {
   
    if(window.location.hash == "#/consultar-chamado") {   
        this.rotate(1);
    }

    else if(window.location.hash == "#/chamado-advogado") {
        this.rotate(2);
    }

    else if(window.location.hash == "#/chamado-delegatario") {
        this.rotate(3);   
    }

    else if(window.location.hash == "#/cadastro-carta-precatoria") {
      this.rotate(4);   
  }
   
  }

  loginTela(){
    this.router.navigate(['login']);
  }

  sairTela(){
    this.identityStorage.clearAuthData();
    localStorage.removeItem('currentUser');
    this.router.navigate(['login']);
  }


  logado(): boolean{
      return this.router.url != '/login';
  }

  ngOnDestroy() {
    return this.authenticationService.isAuthenticated();
  }

  telaHome(){
    this.router.navigate(['home']);
  }

  state1: string = 'default';
  state2: string = 'default';
  state3: string = 'default';
  state4: string = 'default';

  rotate(valor) {

    switch (valor){

      case 1:

       this.state1 = 'up';
       this.state2 = 'default';
       this.state3 = 'default';
       this.state4 = 'default';
      
      break;
     
      case 2:

        this.state1 = 'default';
        this.state2 = 'up';
        this.state3 = 'default';
        this.state4 = 'default';

        break;

      case 3:
      
       this.state1 = 'default';
       this.state2 = 'default';
       this.state3 = 'up';
       this.state4 = 'default';

      break;

      case 4:
      
        this.state1 = 'default';
        this.state2 = 'default';
        this.state3 = 'default';
        this.state4 = 'up';
 
       break;

      default:
      
        this.state1 = 'default';
        this.state2 = 'default';      
        this.state3 = 'default';
        this.state4 = 'default';

      break;

    }
  }
}
